import React from 'react';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import { commafy } from 'helpers/number';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Button } from 'components/form/Button/Button';
import { Image } from 'components/Image/Image';
import { Link } from 'components/navigation/Link/Link';

const PersonalLoanPrequalHighCcDebtExpView = props => {
  const { creditInfo } = props;
  return (
    <FlexContainer
      className={
        'flex-container system_neutral_n000 grayShadow16 margt12 border-rad8px padT40 padB26 m-padT20'
      }
    >
      <Row className="format100 mobilePad8">
        <FlexContainer className="flex-column">
          <FlexContainer className="format100 justify-between m-hide t-hide">
            <FlexContainer className="align-self-center">
              <Image className="personalLoanBannerExpImg" />
            </FlexContainer>
            <FlexContainer className="flex-column margLR16">
              <FlexContainer className="flex-column">
                <Label className="text-18 bold system_neutral_n400_text lineHeight140">
                  Save on credit card interest with a personal loan
                </Label>
                <Label
                  type="Body-2"
                  className={
                    'text-14 m-margt10 system_neutral_n400_text margT8'
                  }
                >
                  Consolidating{' '}
                  <span className="bold">
                    $
                    {commafy(
                      creditInfo?.debtAnalysis?.creditCardDebt?.totalDebt,
                    )}
                  </span>{' '}
                  in credit card debt with a loan could mean a lower APR and
                  smaller monthly payments—helping you save money and pay off
                  debt faster.
                </Label>
              </FlexContainer>
            </FlexContainer>
            <FlexContainer className="align-self-center flex-column format45">
              <Button
                mrphType="primary"
                onClick={props.onClickPrequal}
                className="border-rad100px"
              >
                <Label
                  type="Subtitle-2"
                  color="primary_cta_text_light"
                  className={'text-16 m-text-14'}
                  tabIndex="-1"
                >
                  Pre-Qualify Now
                </Label>
              </Button>
              <Label
                type="Body-2"
                className={
                  'text-11 text-center m-margt10 system_neutral_n400_text margT10'
                }
              >
                No impact to your credit score.
              </Label>
            </FlexContainer>
          </FlexContainer>
          <FlexContainer className="flex-column padLR16 d-hide">
            <FlexContainer justifyBetween alignItemsCenter className="padR16">
              <Label className="text-16 bold system_neutral_n400_text padR16">
                Save on credit card interest with a personal loan
              </Label>
              <Image imgClass={'personalLoanBannerExpImg'} />
            </FlexContainer>
            <Label
              type="Body-2"
              className={'text-14 m-margt10 system_neutral_n400_text margT8'}
            >
              Consolidating{' '}
              <span className="bold">
                ${commafy(creditInfo?.debtAnalysis?.creditCardDebt?.totalDebt)}
              </span>{' '}
              in credit card debt with a loan could mean a lower APR and smaller
              monthly payments—helping you save money and pay off debt faster.
            </Label>
            <FlexContainer className="align-self-center margt18 flex-column format100 padLR16">
              <Button
                fullWidth
                mrphType="primary"
                onClick={props.onClickPrequal}
                className="border-rad100px"
              >
                <Label
                  type="Subtitle-2"
                  color="primary_cta_text_light"
                  className={'text-16 m-text-14 padlr30'}
                  tabIndex="-1"
                >
                  Pre-Qualify Now
                </Label>
              </Button>
              <Label
                type="Body-2"
                className={
                  'text-11 text-center m-margt10 system_neutral_n400_text margT10'
                }
              >
                No impact to your credit score.
              </Label>
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>
      </Row>
    </FlexContainer>
  );
};

export default PersonalLoanPrequalHighCcDebtExpView;
